import ContentHeader from '@/components/ContentHeader';
import SiteMapList from '@/components/SiteMapList';
import SiteMapListChild from '@/components/SiteMapListChild';
import { absoluteServerPath, CDN2, resolveConfigUrl } from '@/helpers/api';
import { cacheFetch } from '@/helpers/cacheFetch';
import { basicPageProps } from '@/utils/isServer';
import { Collapse, Space } from 'antd';
import { GetServerSideProps } from 'next';
import Head from 'next/head';
import React, { useState } from 'react';

const { Panel } = Collapse;

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  // `getStaticProps` is invoked on the server-side,
  // so this `fetcher` function will be executed on the server-side.
  const pageProps = await basicPageProps(ctx);

  const { airports, cities, cruises, facilities, guides, monthlies } =
    await cacheFetch(
      `${absoluteServerPath(pageProps.configInfo)}/api/SitemapData`
    );

  return {
    props: {
      cities,
      airports2: airports,
      airports: pageProps.airports,
      cruises,
      guides,
      monthlies,
      facilities,
      configInfo: pageProps.configInfo,
      FORCE_BLOG_ADDRESS: process.env.FORCE_BLOG_ADDRESS || '',
    },
  };
};

export default function Sitemap({
  airports2,
  cities,
  cruises,
  facilities,
  guides,
  monthlies,
  configInfo,
  FORCE_BLOG_ADDRESS,
}) {
  const [currentStep, setCurrentStep] = useState<number | null>(null);
  function handleTermsCollapseOnChange(current) {
    setCurrentStep(current);
  }
  return (
    <div>
      <Head>
        <title>Site Map | On Air Parking</title>
        <meta name="description" content="Site Map" key="description" />
        <meta
          property="og:url"
          content="https://www.onairparking.com/sitemap"
          key="og:url"
        />
        <meta property="og:type" content="website" key="og:type" />
        <meta
          property="og:title"
          content="Site Map | On Air Parking"
          key="og:title"
        />
        <meta
          property="og:description"
          content="Site Map"
          key="og:description"
        />
        <meta
          property="og:image"
          content={CDN2() + '/staticmyapp/oglogo-white.png'}
          key="og:image"
        />
      </Head>
      <ContentHeader btitle="Site Map" />
      <div className="bg-white">
        <div className="container max-w-4xl px-4 mx-auto py-12">
          <Space direction="vertical" size="middle" className="w-full ">
            <Collapse
              accordion
              activeKey={currentStep}
              onChange={handleTermsCollapseOnChange}
            >
              <Panel
                className="bg-clear-orange"
                header={
                  <div className="text-sm text-primary flex flex-row items-start w-full relative">
                    <span className="ml-2 items-start">Site</span>
                  </div>
                }
                key="1"
                showArrow={true}
                forceRender
              >
                <ul>
                  <li>
                    <a
                      href="https://onairparking.com"
                      title="Home"
                      className="text-primary underline"
                    >
                      https://onairparking.com
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://onairparking.com/contact"
                      title="Contact"
                      className="text-primary underline"
                    >
                      https://onairparking.com/contact
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://onairparking.com/about"
                      title="About"
                      className="text-primary underline"
                    >
                      https://onairparking.com/about
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://onairparking.com/faq"
                      title="F.A.Q."
                      className="text-primary underline"
                    >
                      https://onairparking.com/faq
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://onairparking.com/blog"
                      title="Blog"
                      className="text-primary underline"
                    >
                      https://onairparking.com/blog
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://onairparking.com/privacypolicy"
                      title="Privacy Policy"
                      className="text-primary underline"
                    >
                      https://onairparking.com/privacypolicy
                    </a>
                  </li>

                  <li>
                    <a
                      href="https://onairparking.com/termsofservice"
                      title="Terms of Service"
                      className="text-primary underline"
                    >
                      https://onairparking.com/termsofservice
                    </a>
                  </li>

                  <li>
                    <a
                      href="https://onairparking.com/airports"
                      title="Airports"
                      className="text-primary underline"
                    >
                      https://onairparking.com/airports
                    </a>
                  </li>

                  <li>
                    <a
                      href="https://onairparking.com/city"
                      title="City Parking"
                      className="text-primary underline"
                    >
                      https://onairparking.com/cityparking
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://onairparking.com/cruise"
                      title="Cruise Parking"
                      className="text-primary underline"
                    >
                      https://onairparking.com/cruiseparking
                    </a>
                  </li>

                  <li>
                    <a
                      href="https://onairparking.com/couponcodes"
                      title="Counpon Codes"
                      className="text-primary underline"
                    >
                      https://onairparking.com/couponcodes
                    </a>
                  </li>

                  <li>
                    <a
                      href="https://onairparking.com/cruiseports"
                      title="Cruise Port Parking"
                      className="text-primary underline"
                    >
                      https://onairparking.com/cruiseports
                    </a>
                  </li>

                  <li>
                    <a
                      href="https://onairparking.com/premierparkingusa"
                      title="Premier Parking USA"
                      className="text-primary underline"
                    >
                      https://onairparking.com/premierparkingusa
                    </a>
                  </li>

                  <li>
                    <a
                      href="https://onairparking.com/reviews"
                      title="Reviews"
                      className="text-primary underline"
                    >
                      https://onairparking.com/reviews
                    </a>
                  </li>

                </ul>
              </Panel>
            </Collapse>
            <Collapse
              accordion
              activeKey={currentStep}
              onChange={handleTermsCollapseOnChange}
            >
              <Panel
                className="bg-clear-orange"
                header={
                  <div className="text-sm text-primary flex flex-row items-start w-full relative">
                    <span className="ml-2 items-start">Airports</span>
                  </div>
                }
                key="2"
                showArrow={true}
                forceRender
              >
                {airports2.length > 0 && (
                  <SiteMapListChild items={airports2} facilities={facilities} />
                )}
              </Panel>
            </Collapse>
            <Collapse
              accordion
              activeKey={currentStep}
              onChange={handleTermsCollapseOnChange}
            >
              <Panel
                className="bg-clear-orange"
                header={
                  <div className="text-sm text-primary flex flex-row items-start w-full relative">
                    <span className="ml-2 items-start">Ports</span>
                  </div>
                }
                key="3"
                showArrow={true}
                forceRender
              >
                {cruises?.length > 0 && (
                  <SiteMapListChild items={cruises} facilities={facilities} />
                )}
              </Panel>
            </Collapse>
            <Collapse
              accordion
              activeKey={currentStep}
              onChange={handleTermsCollapseOnChange}
            >
              <Panel
                className="bg-clear-orange"
                header={
                  <div className="text-sm text-primary flex flex-row items-start w-full relative">
                    <span className="ml-2 items-start">Cities</span>
                  </div>
                }
                key="4"
                showArrow={true}
                forceRender
              >
                {cities?.length > 0 && (
                  <SiteMapListChild items={cities} facilities={facilities} />
                )}
              </Panel>
            </Collapse>
            <Collapse
              accordion
              activeKey={currentStep}
              onChange={handleTermsCollapseOnChange}
            >
              <Panel
                className="bg-clear-orange"
                header={
                  <div className="text-sm text-primary flex flex-row items-start w-full relative">
                    <span className="ml-2 items-start">Guides</span>
                  </div>
                }
                key="5"
                showArrow={true}
                forceRender
              >
                {guides.length > 0 && <SiteMapList items={guides} />}
              </Panel>
            </Collapse>
            <Collapse
              accordion
              activeKey={currentStep}
              onChange={handleTermsCollapseOnChange}
            >
              <Panel
                className="bg-clear-orange"
                header={
                  <div className="text-sm text-primary flex flex-row items-start w-full relative">
                    <span className="ml-2 items-start">Monthly Parking</span>
                  </div>
                }
                key="6"
                showArrow={true}
                forceRender
              >
                {monthlies?.length > 0 && <SiteMapList items={monthlies} />}
              </Panel>
            </Collapse>
          </Space>
        </div>
      </div>
    </div>
  );
}
